import React, { FC } from 'react'
import ReactFastMarquee from 'react-fast-marquee'
import * as Styles from './marquee.module.scss'

/**
 * Props for the `Marquee` component.
 */
export type MarqueeProps = {
  /**
   * The content to be displayed inside the marquee.
   *
   * @default null
   */
  children?: React.ReactNode
  /**
   * The direction in which the marquee should scroll.
   *
   * @default "left"
   */
  direction?: 'left' | 'right'
  /**
   * The speed at which the marquee should scroll, in pixels per second.
   *
   * @default 50
   */
  speed?: number
}

/**
 * Horizontal marquee that scrolls text horizontally across the screen indefinitely.
 */
export const Marquee: FC<MarqueeProps> = ({
  children = null,
  direction = 'left',
  speed = 50,
}) => {
  return (
    <div className={Styles.marqueeWrapper}>
      <ReactFastMarquee autoFill direction={direction} speed={speed}>
        <div className={Styles.marqueeItem}>{children}</div>
      </ReactFastMarquee>
    </div>
  )
}
